import { App } from "vue";

const requireComponent = require.context(
	// The relative path of the components folder
	"./",
	// Whether or not to look in subfolders
	true,
	// The regular expression used to match component filenames
	/[A-Z]\w+\.(vue|js)$/
);

/**
 * Composants chargés en `defineAsyncComponent(() => import(...))` côté
 * call-site (cf. AppHeader, FleetTracking, etc.). On les EXCLUT de
 * l'auto-registration globale pour qu'ils ne plombent pas le main
 * bundle. Sans cette exclusion, le lazy-load côté call-site n'apporte
 * aucun gain — webpack continue de les inclure via `require.context`.
 *
 * Quand tu pose un `defineAsyncComponent` quelque part, ajoute le NOM
 * (sans extension) ici.
 */
const LAZY_LOADED_COMPONENTS = new Set<string>([
	// Phase 1 — modal occasionnel global :
	"WizardAssistance",
	// Phase 2 — Leaflet (220 KB lib) :
	"LiveFleetMap",
	"EmbarkationTrailMap",
	// Phase 5 — modals à usage rare ou conditionnel :
	"DriverLinkModal",
	"DeliveryProofModal",
	"FileUploaderModal",
	"PassengerAlertNoEmbarkationModal",
	"PassengerEditModal",
	"PassengerTransferModal",
	"PassengerReplaceModal",
	"ExpenseSettleModal",
]);

const register = (app: App<Element>): void => {
	requireComponent.keys().forEach((fileName) => {
		// Get component name first to skip lazy-loaded components.
		const componentName = fileName
			.split("/")
			.pop()
			?.replace(/\.\w+$/, "") as string;

		if (LAZY_LOADED_COMPONENTS.has(componentName)) {
			return;
		}

		// Get component config
		const componentConfig = requireComponent(fileName);
		app.component(componentName, componentConfig.default || componentConfig);
	});
};

export default {
	register,
};
